import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";


import { createDiseaseAPI, createGroupAPI, createSubGroupAPI, deleteTestCategory, deleteTestSubCategory, listDiseaseAPI, listGroupAPI, listSubGroupAPI, updateDiseaseAPI, updateGroupAPI, updateSubGroupAPI } from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { categoryDDAPI, categoryTestDDAPI, generateFileAPI, groupDDAPI } from "../../api/dropdown";
import MySelect from "../../MyComp/UI/form/MySelect";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";

const SubGroup = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },  
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Table Columns
  const [column, setColumn] = useState([
   
    {
      name: "Image",
      selector: (row) => (
        <div  >
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
           <UserAvatarCell row={row} name={row?.subCategory} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>
          
        </div>
      ),
      sortable: false,
      wrap: true,
    },
     {
      name: "Group Name",
      selector: (row) => row?.categoryName,
      sortable: true,
    },
      {
      name: "Sub Group ",
      selector: (row) => row?.subCategory|| "-",
      sortable: true,
    wrap:true
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>   <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
     setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
        setValue("isLoading", true);

    deleteTestSubCategory({ id: watch("selectedRow").id })
      .then((res) => {
      setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
        //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
        setValue(
  "data",
  watch("data").filter(
    (item) => item.id !== watch("selectedRow")?.id
  )
);

        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Fetch group list
  useEffect(() => {
    getGroupList();
  }, []);

  const getGroupList = async () => {
    try {
      const res = await listSubGroupAPI();
      if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === true) {
        setValue("data", res.data.data);
      } else {
        setValue("data", []);
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };

const onFormSubmit = async (data) => {
  try {
    setValue("isLoading", true);

    const formData = new FormData();

    formData.append("name", data?.name);
    formData.append("status", data?.status?.value);
    formData.append("categoryId", data?.category?.value);

    if (data?.group_img instanceof File) {
      formData.append("image", data.group_img);
    }

    if (mode === "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }

    const res =
      mode === "Add"
        ? await createSubGroupAPI(formData)
        : await updateSubGroupAPI(formData);

    if (res?.data?.status === true) {
      toast.success(res.data.message);
      await getGroupList();
      resetF();
      setIsOpen(false);
    } else if (res?.data?.status === "expired") {
      toast.error(res.data.message);
      logout();
    } else {
      toast.error(res?.data?.message || "Operation failed");
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "Something went wrong");
  } finally {
    setValue("isLoading", false);
  }
};

  const handleEdit = (row) => {
  window.scrollTo(0, 0);

  setMode("Edit");
  setIsOpen(true);

//   reset({
    setValue("name", row?.subCategory || "");
    setValue("category", { label: row?.categoryName, value: row?.categoryId });
    setValue("status", {
      label: row?.status ? "Active" : "Inactive",
      value: row?.status,
    });
    setValue("group_image", `${BASE_URL_IMG}${row?.image}`); // preview URL
    setValue("group_img", null); // FILE must be null
    setValue("addSub", false);
    setValue("selectedRow", row);
//   });
};
    useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
   
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const resetF = () => {
    setValue("group_image", null);
    setValue("group", null);
    setValue("name", null);
      setValue("category", null);
    setValue("status", null);
    setValue("addSub", false);
    setValue("group_img", null);
        clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  const generateFile=()=>{
  
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data,"res.fileee")
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });

  }

  return (
    <>
      <Head title=" Sub Group | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Sub Group
              </BlockTitle>
            </BlockHeadContent>
       <BlockHeadContent className={"me-2"}   >
                <div className="me-2 d-flex g-5 mt-2">
                  {/* <Button
                color="primary"
                outline
                className="me-n1 me-2 pe-2"
                onClick={() => {
                 generateFile()
                  resetF();
                }}
              >
                <Icon name={"file"} />
              </Button> */}
              <Button
                color="primary"
                outline
                className="me-n1  mx-2"
                onClick={() => {
                  setIsOpen((pre) => !pre);
                  setMode("Add");
                  resetF();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button></div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
               <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>

                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Sub Group Name"
                      name="name"
                      placeholder="Enter group name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>

                  <Col md="4">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Sub Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      setError={setError}
                      getValues={getValues}
                    />
                  </Col>

                  <Col md="4">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Sub Group List" isLoading={isLoading} generateFile={generateFile} resetF={resetF} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
 <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default SubGroup;
